import { createStore } from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import saver from './modules/saver'
import pallet from './modules/pallet'
import config from './modules/business/config.js'
import project from './modules/business/project'
import indicatrix from './modules/business/indicatrix'
import view from './modules/business/view'
import trolley from './modules/business/trolley'
import search from './modules/business/search'
import {requestStorePlugin} from '@/utils/request'
import saverPalletSyncPlugin from './plugins/saver-pallet-sync'
import indicatrixProjectSyncPlugin from './plugins/indicatrix-project-sync'
import {createModuleSaverSyncPlugin} from './plugins/module-saver-sync'
const store = createStore(
  {
    modules: {
      app,
      settings,
      user,
      saver,
      pallet,
      config,
      project,
      indicatrix,
      trolley,
      view,
      search
    },
    getters,
    plugins: [
      requestStorePlugin,
      saverPalletSyncPlugin,
      indicatrixProjectSyncPlugin,
      createModuleSaverSyncPlugin('project'),
      createModuleSaverSyncPlugin('indicatrix'),
    ],
    strict: process.env.NODE_ENV !== 'production'
  }
)
export default store
